import { SegmentGroup, Tag } from "@ttc3k/trekker";
import { useTranslation } from "react-i18next";

type TabValue = "results" | "selections";

type ManualListTabsProps = {
  onTabChange: (v: TabValue) => void;
  tab: TabValue;
  searchResultsCount: number;
  mySelectionsCount: number;
};

export const ManualListTabs = ({
  onTabChange,
  tab,
  searchResultsCount,
  mySelectionsCount,
}: ManualListTabsProps) => {
  const { t } = useTranslation("customLists", {
    keyPrefix: "LIST.CREATE_NEW.MANUAL.TABS_LABELS",
  });
  return (
    <SegmentGroup.Root
      onValueChange={(v) => onTabChange(v.value as TabValue)}
      orientation="horizontal"
      visual={"accent.blue"}
      value={tab}
    >
      <SegmentGroup.Item value={"results"}>
        <span>{t("RESULTS")}</span>
        <Tag
          visual={tab === "results" ? "accent.blue" : "primary"}
          mode={"light"}
        >
          {searchResultsCount}
        </Tag>
      </SegmentGroup.Item>
      <SegmentGroup.Item value={"selections"}>
        <span>{t("SELECTIONS")}</span>
        <Tag
          visual={tab === "selections" ? "accent.blue" : "primary"}
          mode={"light"}
        >
          {mySelectionsCount}
        </Tag>
      </SegmentGroup.Item>
    </SegmentGroup.Root>
  );
};
